import { Schema } from 'effect';
import { optionalCatching } from '@/lib/search-params';

/**
 * `?pdf_job` names the running job, so the URL resumes it in any tab or on
 * any device. It is cleared before the reader opens, so going back lands on an
 * empty tool. Every route that renders the converter declares it.
 */
export const pdfToAudioSearch = Schema.toStandardSchemaV1(
  Schema.Struct({ pdf_job: optionalCatching(Schema.String) }),
);
